import { render, staticRenderFns } from "./videoForm.vue?vue&type=template&id=523ddf68&scoped=true&"
import script from "./videoForm.vue?vue&type=script&lang=js&"
export * from "./videoForm.vue?vue&type=script&lang=js&"
import style0 from "./videoForm.vue?vue&type=style&index=0&id=523ddf68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ddf68",
  null
  
)

export default component.exports